import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { PageLayoutStandard, SiteFooterLayout, SiteHeaderProvider } from '@shapeable/ui';
// import { SiteHeaderLayout } from '../entities/site-header-layout';

// -------- Styles -------->

const LayoutStyles = breakpoints({
  base: css`
    /* override title styles via BEM here to affect spacing */ 
    .shp--page-layout-standard__title {
      max-width: 500px;
      font-weight: 600;
    }
  `,
  tablet: css`
  `,
  desktop: css`
  `
});

const FooterStyles = breakpoints({
  base: css`
    
  `,
});


// -------- Components -------->

const My = {
  Layout: styled(PageLayoutStandard)`${LayoutStyles}`,
    Footer: styled(SiteFooterLayout)`${FooterStyles}`,
};

export const PageLayoutDefault: PageLayoutComponent = (props) => {
  const { className, entity, slices } = props;

  const { titleRich, subtitleRich } = entity;

  return (
    <SiteHeaderProvider value={{
      variant: 'default',
    }}>
    <My.Layout 
      className={className}
      entity={entity}
      slices={slices}
      useIntro
      headerProps={{ aspectRatio: 
        { base: 4 / 3, desktop: 21 / 9 }, 
        showOverlayGradient: true, 
        variant: 'overlay', 
        fadeColor: '#0000000', 
        // backgroundColor: '#0000000',
        useBackgroundColor: true }} 
    />
    <My.Footer />
    </SiteHeaderProvider>
  )
};
